module.exports = __webpack_public_path__ + "naghmeh-social-icon--apple-music.svg?40fa61c0c18b2fff89faa411649fe4b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-icons-edited/naghmeh-social-icon--apple-music.svg
// module id = 209
// module chunks = 0